import {
  Container,
  Avatar,
  Tooltip,
  Typography,
  IconButton,
  Box,
} from "@mui/material";
import CeroTable from "../../../components/CeroTable";
import StyledBadge from "../../../components/StyledBadge/input";
import dayjs from "dayjs";
import useStyles from "./styles";
import CreateIcon from "@mui/icons-material/CreateOutlined";

export const approvalMonthlySummaryColumns = [
  {
    columnKey: "ticketStatus",
    columnId: "ticketStatus",
    columnHeader: "",
  },
  {
    columnKey: "ticket_id",
    columnId: "ticket_id",
    columnHeader: "Ticket ID",
  },
  {
    columnKey: "assigned_to_name",
    columnId: "assigned_to_name",
    columnHeader: "Assignee",
  },
  {
    columnKey: "assigned_on",
    columnId: "assigned_on",
    columnHeader: "Assigned on",
  },
  {
    columnKey: "ticket_owner_name",
    columnId: "ticket_owner_name",
    columnHeader: "Ticket Raised by",
  },
  {
    columnKey: "status",
    columnId: "status",
    columnHeader: "Status",
  },
  {
    columnKey: "action",
    columnId: "acton",
    columnHeader: "Action",
  },
];

export const supportTicketColumns = [
  {
    columnKey: "ticket_id",
    columnId: "ticket_id",
    columnHeader: "Ticket ID",
  },
  {
    columnKey: "ticket_type",
    columnId: "ticket_type",
    columnHeader: "Ticket type",
  },
  {
    columnKey: "assigned_on",
    columnId: "assigned_on",
    columnHeader: "Assigned on",
  },
  {
    columnKey: "ticket_owner_name",
    columnId: "ticket_owner_name",
    columnHeader: "Ticket Raised by",
  },
  {
    columnKey: "status",
    columnId: "status",
    columnHeader: "Status",
  },
];

const TicketsTable = (props) => {
  const classes = useStyles();
  const { onSelectTicket, ticketList, userInfo } = props;
  const isSupportPage = window.location.pathname.includes("/support-tickets");

  const getStatus = (status) => {
    if (status === "open") {
      return <Typography className={classes.Open}>Open</Typography>;
    } else if (status === "closed") {
      return <Typography className={classes.Close}>Closed</Typography>;
    } else {
      return <Typography>{status}</Typography>;
    }
  };

  const getTicketStatus = (data) => {
    let dotColor = "";
    let avatarColor = "";
    let title = "";
    if (userInfo.id === data.assigned_to_id) {
      dotColor = "info";
      avatarColor = "#6565d2";
      title = "Ticket assigned to me";
    } else if (userInfo.id === data.ticket_owner_id) {
      dotColor = "error";
      avatarColor = "#cb6b6b";
      title = "My tickets";
    } else {
      dotColor = "success";
      avatarColor = "#44cf44";
      title = "Ticket assigned to others";
    }
    return (
      <StyledBadge
        overlap="circular"
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        variant="dot"
        color={dotColor}
      >
        <Tooltip title={title} placement="top" arrow>
          <Avatar sx={{ bgcolor: avatarColor }}>
            {data?.assigned_to_name?.charAt(0).toUpperCase()}
          </Avatar>
        </Tooltip>
      </StyledBadge>
    );
  };

  const getTicketData = () =>
    ticketList.map((item) => ({
      ...item,
      requested_on: item.assigned_on
        ? dayjs(item.assigned_on).format("DD MMM YYYY HH:mm")
        : "-",
      assigned_on: item.assigned_on
        ? dayjs(item.assigned_on).format("DD MMM YYYY HH:mm")
        : "-",
      status: getStatus(item.status),
      action:
        item.status === "open" &&
        item.is_edit_user &&
        item.ticket_scope === "util" ? (
          <Box className={classes.actionContainer}>
            <IconButton
              className={classes.editIcon}
              onClick={(e) => props.clickEditIcon(e, item.id)}
            >
              <CreateIcon />
            </IconButton>
          </Box>
        ) : (
          ""
        ),
      ticketStatus: getTicketStatus(item),
    }));

  return (
    <Container className={classes.container}>
      <CeroTable
        columns={
          isSupportPage ? supportTicketColumns : approvalMonthlySummaryColumns
        }
        data={getTicketData()}
        hasMore={false}
        loading={false}
        onSelectRow={onSelectTicket}
        classes={{
          tableContainer: isSupportPage ? "" : classes.tableContainer,
        }}
      />
    </Container>
  );
};

export default TicketsTable;
